/* eslint-disable react-hooks/exhaustive-deps */
import App from '../../layout/App';
import React, { useContext, useEffect, useState } from 'react';
import { FormContent, Container } from '../../styles/styles'
import { useNavigate } from 'react-router-dom';
import api from '../../utils/api';
import './styles.css'

import Loading from '../../Components/Loading'
import MessageTitle from '../../Components/MessageTitle';
import InputSearch from '../../Components/InputSearch';
import CardPessoa from '../../Components/CardPessoa';
import profissional from '../../assets/iconesMenu/icone-profissional.svg'
import InfoPage from '../../Components/infoPage';
import { MessageContext } from '../../context/message';
import PaginationC from '../../Components/pagination';
import { PaginationContext } from '../../context/paginationController';

const data = sessionStorage.getItem('inep')
let dataSchoolStorage = JSON.parse(localStorage.getItem('dataSchool'))
let filter = sessionStorage.getItem('filterPE')
function PesquisarProfissional() {
    const [removeLoading, setRemoveLoading] = useState(false)
    const { setErrorMessage } = useContext(MessageContext);
    const { pagination , setPagination } = useContext(PaginationContext);
    const navigation = useNavigate()
    const [aux, setAux] = useState([]);
    const [todos, setTodos] = useState([]);
    const [filtersSelect, setFiltersSelect] = useState(0)
    const [registerWasChanged, setRegisterWasChanged] = useState(0)
    const [dataSchool, setDataSchool] = useState('')
 
    const [configPagination, setConfigPagination] = useState({
        'currentPage': pagination.currentPage,
        'totalView': pagination.totalView,
        'totalPages': 0
    })
    async function getDataProfissional() {
        setRemoveLoading(false)
        await api.get(`/professional/list/?inep=${data}&page=${configPagination.currentPage}&view=${configPagination.totalView}&total=${dataSchoolStorage.theAmountProfessionals}`
        ).then(response => {
            setRegisterWasChanged(response.data.registerWasChanged)
            setTodos(response.data.people)
            setAux(response.data.people)
            setConfigPagination({
                ...configPagination,
                totalPages: response.data.totalPages,
            })
            setPagination({
                'currentPage': response.data.currentPage,
                'totalView': configPagination.totalView
            })
        }).catch((err) => {
            setErrorMessage([{ message: "Erro ao buscar Profissionais", ok: false }])
        })
        setRemoveLoading(true)
    }

    useEffect(() => {
        setDataSchool(dataSchoolStorage)
        getDataProfissional()
    }, [])

    function filterItems(busca) {
        let Filtrados = []
        busca = busca.toUpperCase()
        if (filtersSelect !== 0) {
            Filtrados = todos.filter((aluno) => aluno.completeName.includes(busca) && aluno.wasChanged === filtersSelect)
        }
        else {
            Filtrados = todos.filter((aluno) => aluno.completeName.includes(busca))

        }
        setAux(Filtrados)
    }


    const EditGestor = (code) => {
        sessionStorage.setItem('ProfissionalSelecionado', code)
        navigation('/profissional/editar-identificacao')
    }

    useEffect(() => {
        filters(Number(filter))
    }, [todos])

    function filters(tipo) {
        sessionStorage.setItem('filterPE', tipo)
        setFiltersSelect(tipo)
        let list = []
        if (tipo === 1) {
            list = todos.filter((professional) => professional.wasChanged === true)
        }
        if (tipo === 2) {
            list = todos.filter((professional) => professional.wasChanged === false)
        }
        if (tipo === 0) {
            list = todos
        }
        setAux(list)


    }

    const changeCurrentPage = (numPage) => {
        setConfigPagination({ ...configPagination, currentPage: numPage });
        //fetch a data
        //or update a query to get data
    };

    useEffect(() => {
        getDataProfissional()
    }, [configPagination.currentPage ,configPagination.totalView])

    return (
        <>
            {!removeLoading && <Loading />}
            <App>
                <Container>
                    <InfoPage
                        img={profissional}
                        title={'PROFISSIONAL'}
                        key={"PF7587"}
                        edited={registerWasChanged}
                        notEdited={dataSchool.theAmountProfessionals-registerWasChanged}
                    />
                    <FormContent style={{ backgroundColor: 'transparent', border: 'none' }}>
                        <InputSearch
                            valueInput={e => filterItems(e.target.value)}
                            all={(e) => filters(0)}
                            edited={(e) => filters(1)}
                            notEdited={(e) => filters(2)}
                            totalNumber={`Número de profissionais: ${dataSchool.theAmountProfessionals}`}
                            checked={filtersSelect}
                        />

                        <div className='box-card'>
                            {
                                 !Array.isArray(aux) || aux?.length === 0 ? <MessageTitle message={'Nenhum Dado encontrado'} /> : aux.map((item, index) => {
                                    return (
                                        <CardPessoa
                                            mkey={index + item.codePersonSystem}
                                            name={item.completeName}
                                            wasChanged={item.wasChanged}
                                            onClick={() => EditGestor(item.codePersonSystem)}
                                        />

                                    )
                                })}
                        </div>
                            <PaginationC
                                currentPage={configPagination.currentPage}
                                totalPages={configPagination.totalPages}
                                defaultView={configPagination.totalView}
                                onChangeView={(e) => {setConfigPagination({...configPagination , totalView: Number(e.target.value)})}}
                                changeCurrentPage={(numPage) => changeCurrentPage(numPage)}
                            />
                    </FormContent>
                </Container>
            </App>
        </>
    )

}
export default PesquisarProfissional;